/* eslint-disable func-names */
/**
 * Display the returned message.
 * @param {string} data - data returned from the server's ajax call
 * @param {Object} button - button that was clicked for contact us sign-up
 */
function displayMessage(data, button) {
    $.spinner().stop();
    let status;
    if (data.success) {
        status = 'alert-success';
    } else {
        status = 'alert-danger';
    }

    if(data.status == 429){
        data.msg = $('.contact-us').attr('data-message-rate-limit');
    }

    if ($('.contact-us-signup-message').length === 0) {
        $('body').append(
            '<div class="contact-us-signup-message"></div>',
        );
    }
    $('.contact-us-signup-message')
        .append(`<div class="contact-us-signup-alert text-center ${status}" role="alert">${data.msg}</div>`);

    setTimeout(() => {
        $('.contact-us-signup-message').remove();
        button.removeAttr('disabled');
    }, 3000);
}

function checkHoneypotFields(form) {
    let isBot = false;
    const honeypotFields = form.find('.ohnohoney');

    honeypotFields.each((_i, element) => {
        const thisTarget = $(element);
        if (thisTarget.val() !== '') {
            isBot = true;
        }
    });

    return isBot;
}

module.exports = {
    subscribeContact: function () {
        const startDate = new Date();

        $('form.contact-us').submit(function (e) {
            e.preventDefault();
            const endDate = new Date();
            const form = $(this);
            const button = $('.subscribe-contact-us');
            const url = form.attr('action');
            const isBot = checkHoneypotFields(form);
            const timeDiference = endDate.getTime() - startDate.getTime();
            const timeSpentOnPage = ((timeDiference % 60000) / 1000).toFixed(0);

            if (!isBot && timeSpentOnPage >= 10) {
                $.spinner().start();
                button.attr('disabled', true);
                $.ajax({
                    url: url,
                    type: 'post',
                    dataType: 'json',
                    data: form.serialize(),
                    success: function (data) {
                        displayMessage(data, button);
                        if (data.success) {
                            $('.contact-us').trigger('reset');
                        }
                    },
                    error: function (err) {
                        displayMessage(err, button);
                    },
                });
            }
        });
    },
};
